import images from "./images";

const About = {
    sub: "About Us",
    heading: "Your Trusted Source for Quality Windows & Doors",
    description: [
        "Welcome to Windows & Doors, your premier destination for high-quality windows and doors. We are dedicated to providing exceptional products and services to enhance the beauty, security, and energy efficiency of your home. Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem enim nobis ea quo sint vero laboriosam ex repellendus."
    ],
    experience: {
        year: 20,
        text: "years of experience",
    },
    points: [
        "Wide Selection of Windows & Doors",
        "Professional Installation Services",
        "Energy-Efficient Solutions",
        "Customization Options Available",
        "Expert Consultation & Support",
    ],
    image: {
        src1: images.about1,
        src2: images.about2,
        src3: images.about3,
        alt1: "About-Image 1",
        alt2: "About-Image 2",
        alt3: "About-Image 3",
    },
    button: {
        text: "Contact Us",
        link: "Contact-us"
    }
};

export default About;